module.exports = __webpack_public_path__ + "img/ic_birthday.c291682f.svg";